import {
    SET_KEYWORDS,
    SET_BAD_KEYWORDS,
    SET_PREVIOUS_KEYWORDS
} from '../../actions';

const initialState = {
    list: [],
    badList: [],
    previousList: []
}

function keywordsListReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_KEYWORDS:
            newState.list = action.keywords;
            newState.badList = state.badList;
            newState.previousList = state.previousList;
            return newState;
        
        case SET_BAD_KEYWORDS:
            newState.list = state.list;
            newState.badList = action.badKeywords;
            newState.previousList = state.previousList;
            return newState;

        case SET_PREVIOUS_KEYWORDS: 
            newState.list = state.list;
            newState.badList = state.badList;
            newState.previousList = action.previousKeywords;
            return newState;
        
        default:
            return state;
    }
}

export default keywordsListReducer;
